import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/availability-planning')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
